var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container_home not"},[_c('img',{staticClass:"notFound",attrs:{"src":require("@/assets/images/404.png")}}),_c('div',{staticClass:"textNotFound"},[_vm._v(_vm._s(_vm.$t("content.notFound")))])])}
var staticRenderFns = []

export { render, staticRenderFns }